<main class="msg-page">
  <section class="msg-page__card" aria-live="polite">
    @switch (phase) {
      @case ('not-from-console') {
        <div class="msg-page__badge msg-page__badge--warn"><mat-icon>admin_panel_settings</mat-icon></div>
        <h1 class="msg-page__title">{{ strings['impersonate_from_console_title'] }}</h1>
        <p class="msg-page__body">{{ strings['impersonate_from_console_text'] }}</p>
      }
      @case ('failed') {
        <div class="msg-page__badge msg-page__badge--error"><mat-icon>error_outline</mat-icon></div>
        <h1 class="msg-page__title">{{ strings['impersonate_failed_title'] }}</h1>
        <p class="msg-page__body">{{ strings['impersonate_failed_text'] }}</p>
        <div class="msg-page__actions">
          <button mat-flat-button color="primary" type="button" (click)="closeTab()">{{ strings['close'] }}</button>
        </div>
      }
      @default {
        <mat-spinner class="msg-page__spinner" diameter="28"></mat-spinner>
        <p class="msg-page__body">{{ strings['impersonate_opening'] }}</p>
      }
    }
  </section>
</main>
